export default __webpack_public_path__ + "img/carousel-right.c6ad6895.svg";